var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelefonica(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1041.7 250",
    enableBackground: "new 0 0 1041.7 250",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0066FF",
    d: "M74.6,37.3C74.6,16.7,57.9,0,37.3,0C16.7,0,0,16.7,0,37.3c0,20.6,16.7,37.3,37.3,37.3 C57.9,74.6,74.6,57.9,74.6,37.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0066FF",
    d: "M162.3,37.3C162.3,16.7,145.6,0,125,0c-20.6,0-37.3,16.7-37.3,37.3c0,20.6,16.7,37.3,37.3,37.3 C145.6,74.6,162.3,57.9,162.3,37.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0066FF",
    d: "M250,37.3C250,16.7,233.3,0,212.7,0c-20.6,0-37.3,16.7-37.3,37.3c0,20.6,16.7,37.3,37.3,37.3 C233.3,74.6,250,57.9,250,37.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0066FF",
    d: "M162.3,125c0-20.6-16.7-37.3-37.3-37.3c-20.6,0-37.3,16.7-37.3,37.3c0,20.6,16.7,37.3,37.3,37.3 C145.6,162.3,162.3,145.6,162.3,125"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0066FF",
    d: "M162.3,212.7c0-20.6-16.7-37.3-37.3-37.3c-20.6,0-37.3,16.7-37.3,37.3S104.4,250,125,250 C145.6,250,162.3,233.3,162.3,212.7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#0066FF",
    points: "329.5,95.9 294.8,95.9 294.8,75.2 385.8,75.2 385.8,95.9 351,95.9 351,191.1 329.5,191.1  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0066FF",
    d: "M440.3,141.5c-1.8-10.8-8.9-19-20.7-19c-12.6,0-19.9,8.3-22.4,19H440.3z M458.5,166.3 c-1.8,6.6-12.3,26.5-38.9,26.5c-24.8,0-43-18.2-43-43.9c0-25.7,18.2-43.9,43-43.9c23.2,0,41.4,18.2,41.4,42.2c0,2.5-0.3,4.5-0.5,6 l-0.3,2.3h-62.9c1.8,11.8,10.6,19.9,22.4,19.9c9.8,0,15.7-5.6,17.4-9.1H458.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473.4,
    y: 75.2,
    fill: "#0066FF",
    width: 20.7,
    height: 115.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0066FF",
    d: "M570.2,141.5c-1.8-10.8-8.9-19-20.7-19c-12.6,0-19.9,8.3-22.4,19H570.2z M588.5,166.3 c-1.8,6.6-12.3,26.5-38.9,26.5c-24.8,0-43-18.2-43-43.9c0-25.7,18.2-43.9,43-43.9c23.2,0,41.4,18.2,41.4,42.2c0,2.5-0.3,4.5-0.5,6 l-0.3,2.3h-62.9c1.8,11.8,10.6,19.9,22.4,19.9c9.8,0,15.7-5.6,17.4-9.1H588.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0066FF",
    d: "M610,126.6h-14.1v-19.9H610V94.3c0-12.6,8.1-20.7,20.7-20.7h18.2v18.2h-12.4c-3.3,0-5.8,2.5-5.8,5.8v9.1 h18.2v19.9h-18.2v64.6H610V126.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0066FF",
    d: "M750.5,106.7h19l1.7,8.3h0.8c1.5-1.8,3.5-3.5,5.6-5c3.8-2.5,9.6-5,17.6-5c19,0,33.1,14.1,33.1,35.6v50.5 h-20.7v-48.8c0-10.8-7.5-18.2-18.2-18.2c-10.8,0-18.2,7.5-18.2,18.2v48.8h-20.7V106.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0066FF",
    d: "M960.1,159.7c-2.7,13.2-13.1,33.1-39.7,33.1c-24.8,0-43-18.2-43-43.9c0-25.7,18.2-43.9,43-43.9 c26.7,0,37.1,19.9,39.7,32.3h-20.7c-1.8-4.8-6.6-13.2-19-13.2S898,134,898,148.9c0,14.9,9.9,24.8,22.4,24.8s17.2-8.3,19-14.1 H960.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0066FF",
    d: "M1021,154.7h-17.4c-10.8,0-15.7,4.1-15.7,10.8c0,6.6,4.8,10.8,13.2,10.8c12.6,0,19.9-7.3,19.9-19V154.7z  M1022.6,182.9h-0.8c-1.5,1.8-3.5,3.5-5.8,5c-4,2.5-9.8,5-18.2,5c-19.2,0-30.6-11.8-30.6-25.7c0-16.6,11.6-28.2,34.8-28.2h19v-1.7 c0-9.3-5.6-15.7-14.9-15.7c-9.3,0-14.1,6-14.9,10.8h-20.7c1.8-13.9,13.1-27.3,35.6-27.3c21.5,0,35.6,14.2,35.6,32.3v53.8h-17.4 L1022.6,182.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0066FF",
    d: "M844.2,106.7h20.7v84.4h-20.7V106.7z M866.8,82.3c0-6.8-5.5-12.3-12.3-12.3c-6.8,0-12.3,5.5-12.3,12.3 c0,6.8,5.5,12.3,12.3,12.3C861.3,94.5,866.8,89.1,866.8,82.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0066FF",
    d: "M717.4,148.9c0-14.9-9.9-24.8-22.4-24.8c-12.4,0-22.4,9.9-22.4,24.8c0,14.9,9.9,24.8,22.4,24.8 C707.5,173.7,717.4,163.8,717.4,148.9 M738.1,148.9c0,25.7-18.2,43.9-43.1,43.9c-24.8,0-43-18.2-43-43.9c0-25.7,18.2-43.9,43-43.9 C719.9,105,738.1,123.2,738.1,148.9 M702.5,71.1H724l-19.9,24h-17.4L702.5,71.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelefonica);
export default __webpack_public_path__ + "static/media/telefonica.9d318ac3ad8df8a1bb764f7b3ae1c07c.svg";
export { ForwardRef as ReactComponent };